import { Routes, Route, Navigate } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import NotFound from "./NotFound";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "./Login";
import MsalInstance from "../authorization/AuthorizationProvider";
import Homepage from "./Homepage";
import Datasets from "./Datasets";
import LocatorDataset from "./Datasets/Locators/LocatorDataset";
import ScrewDataset from "./Datasets/Screws/ScrewDataset";
import Model from "./Models";
import LocatorModel from "./Models/Locators/LocatorModel";
import ScrewModel from "./Models/Screws/ScrewModel";
import Predict from "./Predict";
import Settings from "./Settings";
import Help from "./Help";
import EvaluationDashboard from "./Evaluate";
import userHook from '../hooks/userHook';

const AppEntry = () => {
  const { isAdmin, isClient, loading } = userHook();

  return (
    <MsalProvider instance={MsalInstance}>
      <PageLayout>
        <AuthenticatedTemplate>
          <Routes>
            <Route path="/" 
              element={loading ? <div>Loading...</div> : <Homepage />}
            />
            <Route
              path="/datasets"
              element={loading ? <div>Loading...</div> : (isAdmin ? <Datasets /> : <Navigate to="/" />)}
            />
            <Route
              path="/dataset/locators/:page"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <LocatorDataset /> : <Navigate to="/" />)}
            />
            <Route
              path="/dataset/screws/:page"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <ScrewDataset /> : <Navigate to="/" />)}
            />
            <Route
              path="/models"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <Model /> : <Navigate to="/" />)}
            />
            <Route
              path="/model/locators"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <LocatorModel /> : <Navigate to="/" />)}
            />
            <Route
              path="/model/screws"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <ScrewModel /> : <Navigate to="/" />)}
            />
            <Route
              path="/predict"
              element={loading ? <div>Loading...</div> : ( isClient ? <Predict /> : <Navigate to="/" />)}
            />
            <Route
              path="/evaluate"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <EvaluationDashboard /> : <Navigate to="/" />)}
            />
            <Route path="/help" element={<Help />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Routes>
            <Route path="*" element={<Login />} />
          </Routes>
        </UnauthenticatedTemplate>
      </PageLayout>
    </MsalProvider>
  );
};

export default AppEntry;